import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMessaging, onMessage } from 'firebase/messaging';
import { app } from '@/firebase';

const useNotificationHandler = () => {
  const navigate = useNavigate();
  const [orderNotification, setOrderNotification] = useState<any>(null);
  const [isWindowVisible, setIsWindowVisible] = useState(true);
  const [modal, setModal] = useState<boolean>(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsWindowVisible(document.visibilityState === 'visible');
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () =>
      document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  useEffect(() => {
    const messaging = getMessaging(app);

    const unsubscribe = onMessage(messaging, (payload) => {
      try {
        const notificationData = JSON.parse(payload?.data?.data as string);
        if (payload?.data?.screen === 'orderDetail') {
          setOrderNotification(notificationData);

          if (isWindowVisible) {
            setModal(true);
            startRingtone();
          }

          showBrowserNotification(notificationData);
        }
      } catch (err) {
        // console.error('Error handling notification:', err);
      }
    });

    return () => {
      unsubscribe();
    };
  }, [isWindowVisible]);

  const startRingtone = () => {
    if (!audioRef.current) {
      audioRef.current = new Audio('/assets/audio/order-rec.wav');
      audioRef.current.loop = true;
    }

    audioRef.current.play().catch((err) => {
      console.warn('Audio autoplay blocked. Waiting for user gesture...', err);
      document.body.addEventListener(
        'click',
        () => {
          audioRef.current?.play().catch(console.error);
        },
        { once: true },
      );
    });
  };

  const showBrowserNotification = (data: any) => {
    if (Notification.permission === 'granted') {
      new Notification('New Order!', {
        body: `Order ID: ${data.id}`,
        icon: '/assets/images/logo.svg',
      });
    }
  };

  const dismissNotification = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setOrderNotification(null);
  };

  return {
    modal,
    orderNotification,
    setModal,
    dismissNotification,
    navigate,
  };
};

export default useNotificationHandler;
